import { FC } from 'react'
import styles from './Hero.module.scss'
import Image from 'next/image'
import { HeroProps as Props } from 'features/encyclopedia/types'

const Hero: FC<Props> = ({ category, subCategory }) => {
  // Constants
  const title: string = subCategory ?? category?.title

  return (
    <section className="container">
      <div className={styles.hero} style={{ backgroundColor: category?.color }}>
        <div className={styles['title-wrapper']}>
          <h1 className={styles.title}>{title}</h1>
          {subCategory && (
            <>
              <br />
              <h4>{category?.title}</h4>
            </>
          )}
        </div>
        {category.icon && (
          <figure className={styles['img-wrapper']}>
            <Image layout="fill" src={category.icon} />
          </figure>
        )}
      </div>
    </section>
  )
}

export default Hero
